var Model = require('../Model');
var model = Object.create(Model);

model.name = 'Bacnet Object';
model['@class'] = 'BacnetObject';
model.url = 'bacnetobject';
model.isNetworkModel = true;
model.fields = {
  parent: {
    default: null,
    hidden: true
  },
  name: {
    type: 'text',
    default: null,
  },
  objectId: {
    type: 'text',
    default: null,
  },
  objectType: {
    type: 'text',
    default: null,
  },
  error: {
    default: null,
  },
  status: {
    default: null,
  },
  description: {
    type: 'text',
    default: null,
  },
  // Optional text metadata discovered from devices
  // For multi-state objects: array of labels (1..N)
  stateText: {
    default: null,
  },
  // For binary objects: labels for 0/1 states
  activeText: {
    type: 'text',
    default: null,
  },
  inactiveText: {
    type: 'text',
    default: null,
  }
};

module.exports = model;
